import React, { useEffect, useState } from 'react';
import "./FabLeaderboard.css";
import { useDomain } from '@useDomain';

import api from '@api';
import { NavLink } from 'react-router-dom';

function FabLeaderboard() {
  const { domain, slug } = useDomain();
  const [topPoints, setTopPoints] = useState([]);
  const [topThrees, setTopThrees] = useState([]);
  const [topTeams, setTopTeams] = useState([]);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const fetchRecords = async () => {
      try {
        const [pointsRes, threesRes, teamRes] = await Promise.all([
          api.get('/api/records/top20Points', {
            params: slug ? { slug } : { domain },
          }),
          api.get('/api/records/top20Threes', {
            params: slug ? { slug } : { domain },
          }),
          api.get('/api/records/top20TeamWins', {
            params: slug ? { slug } : { domain },
          }),
        ]);

        setTopPoints(pointsRes.data);
        setTopThrees(threesRes.data);
        setTopTeams(teamRes.data);
        setLoaded(true); // ✅ mark as loaded
      } catch (err) {
        console.error("Failed to load records", err);
      }
    };

    fetchRecords();
  }, [domain, slug]);


  const maxPoints = Math.max(...topPoints.map(p => p.totalPoints)) || 1;
  const maxThrees = Math.max(...topThrees.map(p => p.totalThrees)) || 1;
  const maxWins = Math.max(...topTeams.map( t => t.wins)) || 1;
console.log(topTeams)

  return (
    <div className="leader-board-container">
      {loaded && (
        <section className="current-leader-section">
          <div className="leaderboards-flex">

            {/* Points Leaders */}
            <div className="leaderboard-wrapper">
              <h3>🏀 FAB All-Time Points Leaders</h3>
              {topPoints.map((tp, index) => {
                const percent = (tp.totalPoints / maxPoints) * 100;

                return (
                  <div className="record-bar-row" key={tp.id}>
                    <div className="record-bar">
                      <div className="bar-and-score">
                        <span className="record-rank">{index + 1}</span>
                        <div className={`bar-fill ${index === 0 ? 'gold-bar' :
                          index === 1 ? 'silver-bar' :
                            index === 2 ? 'bronze-bar' : ''
                          }`}
                          style={{ width: `${percent}%` }}>
                          <NavLink
                            to={slug ? `/${slug}/players/${tp.id}` : `/players/${tp.id}`}
                            className={`record-name-inside ${index === 0 ? 'top-player-name' : ''}`}
                          >
                            {tp.firstName} {tp.lastName}
                          </NavLink>
                        </div>
                        <span className="record-score-outside">{tp.totalPoints}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* 3-Point Leaders */}
            <div className="leaderboard-wrapper">
              <h3>🎯 FAB All-Time 3-Point Leaders</h3>
              {topThrees.map((tt, index) => {
                const percent = (tt.totalThrees / maxThrees) * 100;

                return (
                  <div className="record-bar-row" key={tt.id}>
                    <div className="record-bar">
                      <div className="bar-and-score">
                        <span className="record-rank">{index + 1}</span>
                        <div className={`bar-fill ${index === 0 ? 'gold-bar' :
                          index === 1 ? 'silver-bar' :
                            index === 2 ? 'bronze-bar' : ''
                          }`}
                          style={{ width: `${percent}%` }}>

                          <NavLink
                            to={slug ? `/${slug}/players/${tt.id}` : `/players/${tt.id}`}
                            className={`record-name-inside ${index === 0 ? 'top-player-name' : ''}`}
                          >
                            {tt.firstName} {tt.lastName}
                          </NavLink>
                        </div>
                        <span className="record-score-outside">{tt.totalThrees}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>





            <div className="leaderboard-wrapper">
              <h3>🏆 FAB All-Time Team Wins</h3>
              {topTeams.map((tteam, index) => {
                const percent = (tteam.wins / maxWins) * 100;

                return (
                  <div className="record-bar-row" key={tteam.teamId}>
                    <div className="record-bar">
                      <div className="bar-and-score">
                        <span className="record-rank">{index + 1}</span>
                        <div
                          className={`bar-fill ${index === 0 ? "gold-bar" :
                            index === 1 ? "silver-bar" :
                              index === 2 ? "bronze-bar" : ""
                            }`}
                          style={{ width: `${percent}%` }}
                        >
                          <NavLink
                            to={slug ? `/${slug}/teams/${tteam.teamId}` : `/teams/${tteam.teamId}`}
                            className={`record-name-inside ${index === 0 ? 'top-player-name' : ''}`}
                          >
                            {tteam.name}
                          </NavLink>
                        </div>
                        <span className="record-score-outside">{tteam.wins}</span>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>




          </div>
        </section>
      )}
    </div>
  );
}

export default FabLeaderboard;

